/** Shown on the first wizard step when an invitation link can't be used. */
export const INVALID_INVITE_MESSAGE = 'This invitation link is invalid or has expired.';

export interface InviteDetails {
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  invite_accepted?: boolean | null;
  returningUser?: boolean | null;
  returningUserId?: string | null;
}

interface ValidateInviteResult {
  data?: { validateInvite?: InviteDetails | null } | null;
  errors?: ReadonlyArray<unknown> | null;
}

/**
 * The invite from a `validateInvite` response, or null when the link can't be used (unknown,
 * accepted or expired code: the backend answers with an error; SPO-1221 also lands here).
 */
export function inviteFromResponse(
  result: ValidateInviteResult | null | undefined,
): InviteDetails | null {
  if (!result || result.errors?.length) return null;
  return result.data?.validateInvite ?? null;
}
